import http from "@/apis/http";
import url from "@/config/url";

const game = url.game;

export default {
  result: {
    getData: (params) => http.post(game.result.search, params),
    getColumns: (params) => http.post(game.result.columns, params),
  },
  invest: {
    getData: (params) => http.post(game.invest.search, params),
    getColumns: (params) => http.post(game.invest.columns, params),
  },
  bet: {
    getData: (params) => http.post(game.bet.search, params),
    getColumns: (params) => http.post(game.bet.columns, params),
  },
  language: {
    getData: (params) => http.post(game.language.search, params),
    getDetail: (params) => http.post(game.language.detail, params),
    getCompetition: (params) => http.post(game.language.competition, params),
    updateCompetition: (params) => http.post(game.language.update_competition, params),
    getTeam: (params) => http.post(game.language.team, params),
    updateTeam: (params) => http.post(game.language.update_team, params),
    getColumns: (params) => http.post(game.language.columns, params),
  },
};
